<script>
import Modal from '../Modal.vue';

export default {
  props: {
    email: String,
    emailEdit: String
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      isFetching: false,
      requested: false,
      newEmail: "",
      newUserEmail: ""
    }
  },
  methods: {
    setFormData() {
      this.newUserEmail = this.email === "-" ? "" : this.email;
    },
    closeModal() {
      this.requested = false;
      this.newEmail = false;
      this.isVisible = false;
      this.setFormData();
    },
    openModal() {
      this.isVisible = true;
    },
    onConfirm() {
      if (this.isLoading) {
        return;
      }

      if (this.newUserEmail == "") {
        alertModal.alert("メールアドレスを入力してください。")
        return;
      }

      this.isLoading = true;
      this.submitEmail();
    },
    async submitEmail() {
      const emailData = { email: this.newUserEmail };
      $.post(this.emailEdit, emailData)
        .done(() => {
          this.requested = true;
          this.isVisible = true;
          this.isLoading = false;
        })
        .fail((err) => {
          alertModal.alert("入力されたメールアドレスは無効です。正しい形式で入力してください。");
          this.isLoading = false;
        });
    },
    async getEmailData() {
      this.isFetching = true;
      $.get(this.emailEdit)
        .done((data) => {
          this.requested = data?.requested || false;
          this.newEmail = data?.newEmail || "";
        })
        .fail((err) => {
          alertModal.alert("指定されたユーザーは存在しません。");
          this.isVisible = false;
        })
        .always(() => {
          this.isFetching = false;
        });;
    },
    goBack() {
      window.location.reload()
    }
  },
  computed: {
    isEmailEmpty() {
      return this.email === "-";
    },
    loadingClass() {
      return this.isLoading ? "loading" : "";
    },
    isRequestedOrNewEmail() {
      return this.requested || this.newEmail;
    },
    isEdit() {
      return !this.requested && !this.newEmail;
    },
    isOpen() {
      if (this.isVisible) {
        this.setFormData();
        this.getEmailData();
      }
      return this.isVisible;
    }
  },
  components: {
    Modal,
  },
}
</script>
<template>
  <Modal
    v-if="isOpen"
    @closeModal="closeModal"
    :has-title-divider="true"
    :has-footer-divider="requested"
  >
    <template v-slot:header-title v-if="isEdit">
      <span>メールの変更</span>
    </template>
    <template v-slot:content>
      <div v-if="isFetching" class="loading-wrapper">
        <div class="loading loading-lg"></div>
      </div>
      <div v-else class="content-wrapper">
        <div v-if="requested" class="email-sent-container">
          <div class="empty-icon">
            <i class="icon icon-2x icon-mail"></i>
          </div>
          <p class="empty-title h5 email-title-text">
            確認メールをお送りしました。
          </p>
          <h6 class="empty-subtitle">
            ご入力いただいた変更後のメールアドレスに確認メールをお送りしました。変更後のアドレスに送られているメールのリンクにアクセスしてアドレス変更を完了させてください。
          </h6>
        </div>
        <div v-else-if="newEmail" class="email-sent-container">
          <div class="empty-icon">
            <i class="icon icon-2x icon-link"></i>
          </div>
          <p class="empty-title h5 email-title-text">
            アドレス変更が完了しました。
          </p>
          <h6 class="empty-subtitle">
            メールアドレスの変更が完了しました。以後、oplusからのメールでのご連絡は{{newEmail}}宛に送られます。
          </h6>
        </div>
        <form v-else @keyup.enter="onConfirm">
          <div class="form-group">
            <label class="form-label form-label-email">現在のメール</label>
          </div>
          <div class="edit-email">
            <div class="col-12 user-new-input-dash br-5 non-edit-email">
                <label v-if="isEmailEmpty" class="form-label-dash user-new-form-email">ログインメールなし</label>
                <label v-else class="form-label-dash user-new-form-email">{{email}}</label>
            </div>
          </div>
          <div class="form-group">
            <div class="col-3">
              <label class="form-label form-label-email" for="dom-input-email">新しいメール</label>
            </div>
            <div class="col-12">
              <input v-model="newUserEmail" class="form-input user-new-form-dash-email br-5" name="email" type="text" placeholder="メールアドレス" @keydown.enter.prevent @keyup.enter.prevent="onConfirm">
            </div>
          </div>
        </form>
      </div>
    </template>
    <template v-slot:footer-btn v-if="isEdit && !isFetching">
      <button class="oplus-modal-btn oplus-alt-confirm-btn submit-email-btn" :class="loadingClass" @click="onConfirm" type="button">変更</button>
    </template>
    <template v-slot:footer-btn v-if="isRequestedOrNewEmail && !isFetching">
      <button class="oplus-modal-btn oplus-alt-confirm-btn" @click="goBack" type="button">戻る</button>
    </template>
  </Modal>
</template>
<style scoped>
  .content-wrapper {
    max-width: 576px;
    width: 80vw;
  }

  .form-label-email {
    padding: 10px 0px 0px 6px;
  }

  .user-new-form-dash-email {
    border-radius: 2px;
    padding: 0px 0px 1px 15px;
    height: 40px;
  }

  .non-edit-email {
    border: none;
    background-color: #E9EBEC;
  }

  .email-sent-container {
    text-align: center;
    padding: 10px 15px;

  }

  .email-title-text {
    color: #5F6B71;
    font-size: 20px;
    font-weight: 500;
    line-height: 23.44px;
    text-align: center;
    margin: 20px;
  }
  .loading-wrapper {
    height: 100px;
    width: 300px;
    overflow: hidden;
  }
  .loading-wrapper .loading {
    height: 100%;
  }
</style>
